module.exports = __webpack_public_path__ + "img/google_icon_white.cb9f65d0.png";